module.exports = __webpack_public_path__ + "img/94.96c6abbe.jpg";